
import { mapGetters } from "vuex";
import SpReviewItem from "~/components/v2/splash/sp-review-item.vue";

export default {
  components: {
    SpReviewItem,
  },
  data() {
    return {
      groupsCount: 2,
      dateFormatOptions: {
        year: "2-digit",
        month: "short",
        day: "2-digit",
      },
    };
  },
  computed: {
    ...mapGetters({
      discreetMode: "getDiscreetStatus",
      reviewsSlider: "sliders/getLastReviews",
      reviews_count: "sliders/getReviewsCount",
    }),
    reviewsGroups() {
      const groups = [];
      for (let i = 0; i < this.groupsCount; i++) {
        groups.push(this.reviewsSlider.slice(i * 3, i * 3 + 3));
      }
      return groups;
    },
  },
  mounted() {
    if (window.innerWidth < 768) {
      this.groupsCount = 1;
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth < 768) {
        this.groupsCount = 1;
      } else {
        this.groupsCount = 2;
      }
    });
    setTimeout(() => {
      this.setReviewHeight();
    }, 1000);
  },
  methods: {
    setReviewHeight() {
      const reviews = document.querySelectorAll(".sp-review-item");
      let maxHeight = 0;
      reviews.forEach((review) => {
        if (review.clientHeight > maxHeight) {
          maxHeight = review.clientHeight;
        }
      });
      reviews.forEach((review) => {
        review.style.height = `${maxHeight}px`;
      });
    },
  },
};
